<nav *ngIf="isHome" class="navbar navbar-expand-lg lightDarkPurple">
  <div class="container-fluid customGapping">
    <a class="navbar-brand" routerLink="">
      <img [src]="logoURL" class="img-fluid logoWidth" alt="instacity-logo" />
    </a>
    <div class="btn-group text-start">
      <button
        type="button"
        class="btn dropdown-toggle custom-btnShadow"
        data-bs-toggle="dropdown"
        data-bs-display="static"
        aria-expanded="false"
      >
        <img
          src="../../../../assets/instaciti-new-img/globe (1) 1.svg"
          class="img-fluid logoWidth42 me-2"
          alt="glob-logo"
        />
        <span *ngIf="selectedCountry">{{ selectedCountry.CountryName }}</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-lg-end">
        <li *ngFor="let country of countries">
          <button
            class="dropdown-item"
            type="button"
            (click)="selectCountry(country)"
          >
            {{ country.CountryName }}
          </button>
        </li>
      </ul>
    </div>
    <a
      class="nav-link font16 font600 btn btn-sm custom-btnShadow text-white orangeGradientButton mobileViewDisaplay"
      href="http://join.instaciti.com/jff"
      target="_blank"
    >
      JOIN FOR FREE
    </a>
    <div
      class="collapse navbar-collapse desktopViewDisaplay"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item font16 font600 colorLightBlack me-3">
          <a
            class="nav-link active"
            aria-current="page"
            href="http://join.instaciti.com/jff"
            target="_blank"
            ><img
              src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/get-app.svg"
              class="img-fluid me-1"
              alt="getApp"
            />Get App</a
          >
        </li>
        <li class="nav-item me-3 desktopViewDisaplay">
          <a
            class="nav-link font16 font600 btn btn-sm custom-btnShadow text-white orangeGradientButton"
            href="http://join.instaciti.com/jff"
            target="_blank"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            data-bs-html="true"
            title='
                            <div>Sign Up now & get your free signature
                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        '
          >
            JOIN FOR FREE
          </a>
        </li>
        <li class="nav-item customColor">
          <a class="nav-link font16" (click)="support()">Support</a>
        </li>
        <li><a class="nav-link font16">|</a></li>
        <li class="nav-item customColor">
          <a
            class="nav-link font16"
            href="http://eol.instaciti.com/login2"
            target="_blank"
            >Login</a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>
<nav *ngIf="!isHome" class="navbar navbar-expand-lg lightDarkPurple">
  <div class="container-fluid customGapping">
    <a class="navbar-brand" href="#">
      <img
        src="../../../../assets/instaciti-new-img/instaciti_beta 1.svg"
        class="img-fluid logoWidth"
        alt="instacity-logo"
      />
    </a>

    <div class="listingSearch ms-5">
      <div class="row">
        <div class="col-md-12">
          <div class="input-group">
            <span class="input-group-text lightDarkPurple border-end-0">
              <img
                src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/location-pin.svg"
                class="img-fluid"
                alt="location-icon"
              />
              <span class="font16 font500 ms-1 styled-select">
                <input
                    class="form-control customInput lightDarkPurple lightDarkPurple-focus border-0"
                    list="datalistOptions2"
                    placeholder="Type to search..."
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    name="searchText"
                    [(ngModel)]="searchText"
                    (keyup)="getNearBy()"
                    (focus)="getNearBy()"
                    autocomplete="off"
                  />
                  <ul
                    class="dropdown-menu p-3"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li class="lightDarkPurple p-2 rounded customPurple">
                      <img
                        class="img-fluid"
                        src="../../../../assets/instaciti-new-img/Group 17.svg"
                        alt="location"
                      />
                      <span class="locationText" (click)="setCurrentLocation()"
                        >Detect current location</span
                      >
                    </li>
                    <ng-container>
                      <p class="font18 font500 customPurple mt-3">
                        Popular cities
                      </p>
                      <ng-container *ngFor="let city of popularCities">
                        <li>
                          <a
                            class="dropdown-item"
                            (click)="selectPopularCity(city)"
                          >
                            <p class="listMuted mb-0">
                              {{ city.CityName }}
                            </p>
                          </a>
                        </li>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="searchText">
                      <p class="font18 font500 customPurple mt-3">
                        Nearby Location
                      </p>
                      <ng-container *ngFor="let city of nearby">
                        <li>
                          <a
                            class="dropdown-item"
                            (click)="selectNearByCity(city)"
                          >
                            <p class="listMuted mb-0">
                              {{ city.LocName }}
                            </p>
                          </a>
                        </li>
                      </ng-container>
                    </ng-container>
                  </ul>
              </span>
            </span>
            <input
                class="form-control customInput p-3 border-start-0 border-end-0"
                placeholder="Type to search..."
                (keyup)="search($event)"
                (focus)="search($event)"
                [matAutocomplete]="keywords"
                [(ngModel)]="selectedKeyWord.Keywd"
                [ngModelOptions]="{standalone: true}"
              />
              <mat-autocomplete
                #keywords="matAutocomplete"
                (optionSelected)="onChange($event.option.value)"
              >
                <mat-option *ngFor="let item of searchResult" [value]="item">
                  {{ item.Keywd }}
                </mat-option>
              </mat-autocomplete>

            <span class="input-group-text bg-white border-start-0"
              ><img
                src="../../../../assets/instaciti-new-img/Vector (5).svg"
                alt="location-icon"
              />
            </span>
          </div>
        </div>
      </div>
    </div>

    <a
      class="nav-link font14 font500 btn btn-sm custom-btnShadow text-white orangeGradientButton mobileViewDisaplay"
      target="_blank"
      href="http://join.instaciti.com/jff"
    >
      JOIN FOR FREE
    </a>
    <div
      class="collapse navbar-collapse desktopViewDisaplay"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item me-3 desktopViewDisaplay">
          <a
            class="nav-link font14 font500 btn btn-sm custom-btnShadow text-white orangeGradientButton"
            href="http://join.instaciti.com/jff"
            target="_blank"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            data-bs-html="true"
            title='
                          <div>Sign Up now & get your free signature
                              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                          </div>
                      '
          >
            JOIN FOR FREE
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
